var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95817 16.5V8.25M1.4165 9.75V15C1.4165 15.8284 2.05077 16.5 2.83317 16.5H12.3434C13.3923 16.5 14.2842 15.6897 14.4437 14.5921L15.2065 9.34213C15.4046 7.97917 14.4086 6.75 13.1062 6.75H10.6248C10.2336 6.75 9.9165 6.41421 9.9165 6V3.34938C9.9165 2.328 9.13451 1.5 8.16987 1.5C7.93978 1.5 7.73128 1.64347 7.63784 1.86609L5.14513 7.8046C5.03144 8.07545 4.77777 8.25 4.49784 8.25H2.83317C2.05077 8.25 1.4165 8.92157 1.4165 9.75Z",
    stroke: "#AFAFAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsup);
export default __webpack_public_path__ + "static/media/thumbsup.718ed7e5e0da31ca0a7c10f7952e4296.svg";
export { ForwardRef as ReactComponent };